import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { articles } from "@/mocks/articles";

const quickList = articles.slice(0, 3);

export default function HeroSection() {
  return (
    <section className="relative isolate w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=bold%20stylized%20editorial%20poster%20illustration%20with%20deep%20charcoal%20background%2C%20layered%20coral%20red%20and%20amber%20gold%20geometric%20paper%20shapes%2C%20halftone%20dots%20and%20grain%20texture%2C%20dramatic%20moody%20lighting%20with%20rich%20shadows%20on%20the%20left%20side%2C%20abstract%20collage%20art%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=1800&height=1100&seq=gw-hero-main-2026&orientation=landscape"
          alt="瓜田日报爆料吃瓜每日合集主题配图"
          title="爆料吃瓜每日合集"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-[1280px] flex-col gap-12 px-4 pb-16 pt-32 md:px-8 md:pb-24 md:pt-44 lg:flex-row lg:items-end">
        <div className="w-full animate-fade-up lg:w-3/5">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-flashlight-fill text-[12px] text-accent-400"></i>
            </span>
            今日合集已更新 · 2026 年 9 月 10 日
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-[3.4rem]">
            <span className="block text-base font-bold tracking-[0.3em] text-accent-400 md:text-lg">
              {siteInfo.name}
            </span>
            <span className="mt-3 block">
              爆料吃瓜每日合集
              <br />
              看这一篇就够
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-50/85 md:text-base">
            {siteInfo.intro}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/daily"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-newspaper-line text-base"></i>
              </span>
              看今日合集
            </Link>
            <Link
              to="/ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-background-50/15"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-bar-chart-2-line text-base"></i>
              </span>
              热门盘点榜单
            </Link>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4 border-t border-background-50/20 pt-6">
            <div>
              <dt className="text-xs text-background-50/70">今日话题</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-background-50">38 条</dd>
            </div>
            <div>
              <dt className="text-xs text-background-50/70">本周合集</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-background-50">7 期</dd>
            </div>
            <div>
              <dt className="text-xs text-background-50/70">收录分类</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-background-50">6 类</dd>
            </div>
          </dl>
        </div>

        <div className="w-full animate-fade-up rounded-card border border-background-50/15 bg-background-50/10 p-5 backdrop-blur-md lg:w-2/5">
          <div className="flex items-center justify-between">
            <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-background-50">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-alarm-warning-line text-accent-400"></i>
              </span>
              头条速览
            </h2>
            <span className="text-xs text-background-50/60">刚刚更新</span>
          </div>
          <ul className="mt-4 flex flex-col divide-y divide-background-50/12">
            {quickList.map((article, index) => (
              <li key={article.slug}>
                <Link
                  to={`/article/${article.slug}`}
                  className="group flex items-start gap-3 py-3.5"
                >
                  <span className="font-heading text-lg font-bold text-accent-400/80">
                    0{index + 1}
                  </span>
                  <span className="flex-1">
                    <span className="block text-sm font-medium leading-snug text-background-50/95 transition-colors duration-200 group-hover:text-accent-300">
                      {article.title}
                    </span>
                    <span className="mt-1.5 flex items-center gap-2 text-xs text-background-50/60">
                      <span className="rounded-full bg-background-50/15 px-2 py-0.5">
                        {article.category}
                      </span>
                      热度持续上升
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to="/daily"
            className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-accent-300 transition-colors duration-200 hover:text-accent-200"
          >
            查看全部速览
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}